import React from 'react';
import ScrollToTopButton from './components/ScrollToTopButton';
import { BrowserRouter as Router, useLocation } from 'react-router-dom';
import { CSSTransition, SwitchTransition } from 'react-transition-group';
import Navbar from './components/Navbar';
import HomePage from './pages/HomePage';
import ContactPage from './pages/ContactPage';
import Login from './components/Login';
import Footer from './components/Footer';
import NotFound from './components/NotFound';
import LoadingScreen from './components/LoadingScreen';

const PeopleEditor = React.lazy(() => import('./components/PeopleEditor'));
const ResearchEditor = React.lazy(() => import('./components/ResearchEditor'));
const LabEditor = React.lazy(() => import('./components/LabEditor'));
const PublicationsEditor = React.lazy(() => import('./components/PublicationsEditor'));

function AnimatedRoutes() {
    const location = useLocation();
    const pageRef = React.useRef(null);
    let PageComponent = null;
    switch (location.pathname) {
        case '/':
            PageComponent = <HomePage />;
            break;
        case '/people':
            PageComponent = <PeopleEditor />;
            break;
        case '/research':
            PageComponent = <ResearchEditor />;
            break;
        case '/lab':
            PageComponent = <LabEditor />;
            break;
        case '/publications':
            PageComponent = <PublicationsEditor />;
            break;
        case '/contact':
            PageComponent = <ContactPage />;
            break;
        case '/login':
            PageComponent = <Login />;
            break;
        default:
            // For unknown routes, show 404 page
            PageComponent = <NotFound />;
    }
    return (
        <SwitchTransition mode="out-in">
            <CSSTransition
                key={location.pathname}
                classNames="fade"
                timeout={350}
                nodeRef={pageRef}
                unmountOnExit
            >
                <div className="page" ref={pageRef}>
                    {PageComponent}
                </div>
            </CSSTransition>
        </SwitchTransition>
    );
}

function App() {
    const [fadeOut, setFadeOut] = React.useState(false);
    const [showLoader, setShowLoader] = React.useState(true);

    React.useEffect(() => {
        const fadeTimer = setTimeout(() => setFadeOut(true), 1000);
        const unmountTimer = setTimeout(() => setShowLoader(false), 1700);
        return () => {
            clearTimeout(fadeTimer);
            clearTimeout(unmountTimer);
        };
    }, []);

    return (
        <Router>
            {showLoader && <LoadingScreen fadeOut={fadeOut} />}
            <div className="app-layout">
                <Navbar />
                <ScrollToTopButton />
                <main className="main-content">
                    <React.Suspense fallback={null}>
                        <AnimatedRoutes />
                    </React.Suspense>
                </main>
                <Footer />
            </div>
        </Router>
    );
}

export default App;
